export default __webpack_public_path__ + "static/media/1_0.bd6fd0b7.png";